import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import { useRautReportOps } from 'pages/reporting/reports/raut/RautReportProvider'
import dra from 'pages/reporting/reports/raut/sections/assets/DRA.png'
import { PageFooter } from 'pages/reporting/shared/pdfGeneration/components/shared/PageFooter'
import { PageHeader } from 'pages/reporting/shared/pdfGeneration/components/shared/PageHeader'
import { PDFStyles } from 'pages/reporting/shared/pdfGeneration/styles/PDFStyles'
import { PdfProps, StaticSection } from 'pages/reporting/shared/types'
import React, { useRef } from 'react'

const styles = StyleSheet.create({
  fullPageContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '10px 10px 10px',
    padding: 0,
  },
  fullPageImageContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  fullPageImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
})

const RenderPDF: React.FC<PdfProps> = ({ onRender }) => {
  const hasRegistered = useRef(false)
  const { formData } = useRautReportOps()
  return (
    <Page size='A4' style={PDFStyles.page} id='dra-table'>
      <Text
        render={({ pageNumber }) => {
          if (!hasRegistered.current) {
            onRender({ id: 'dra-table', pageNumber })
            hasRegistered.current = true
          }
          return ''
        }}
      />

      <PageHeader title='Damage Rating Assessment Table (GR-DRA)' />

      <View style={styles.fullPageContent}>
        <View style={styles.fullPageImageContainer}>
          <Image src={dra} style={styles.fullPageImage} />
        </View>
      </View>

      <PageFooter
        jobNumber={formData.coverPageData.geckoJobId}
        revisionNumber={formData.revisionMetadata.revisionNumber}
        prelim={
          !(
            formData.signoff?.reviewerSignoff &&
            formData.signoff.supervisorSignoff
          )
        }
      />
    </Page>
  )
}

export const DamageRatingAssessmentPage: StaticSection = {
  id: 'dra-table',
  title: 'Damage Rating Assessment Table',
  RenderPDF,
}
